import { trigger, state, animate, transition, style, group } from '@angular/animations';

export const flyInOutAnimation = trigger('flyInOut', [
    state('in', style({ transform: 'translateX(-100%)', opacity: 0})),
    transition('void => *', [
      style({ transform: 'translateY(-100%)', opacity: 0}),
      group([
        animate('0.3s 0.1s ease-out', style({
          transform: 'translateY(0)',

        })),
        animate('.2s ease-in', style({
          opacity: 1
        }))
      ])
    ]),
    transition('* => void', [
      group([
        animate('0.3s ease', style({
          transform: 'translateX(-100%)',

        })),
        animate('0.3s 0.2s ease', style({
          opacity: 0
        }))
      ])
    ])
  ]);

  export const flyInOutLeftAnimation = trigger('flyInOutLeftAnimation', [
    state('in', style({ transform: 'translateX(-100%)', opacity: 0})),
    transition('void => *', [
      style({ transform: 'translateX(-100%)', opacity: 0}),
      group([
        animate('0.15s 0.1s ease-out', style({
          transform: 'translateX(0)',

        })),
        animate('.15s ease-out', style({
          opacity: 1
        }))
      ])
    ]),
    transition('* => void', [
      group([
        animate('0.15s ease', style({
          transform: 'translateX(-100%)',

        })),
        animate('0.15s 0.05s ease-in', style({
          opacity: 0
        }))
      ])
    ])
  ]);
